import classNames from 'classnames'
import styles from 'components/Layout/Layout.module.scss'
import { ultramarine } from 'components/Fonts/Fonts'
import dynamic from 'next/dynamic'
import useMobileNavState from 'hooks/useMobileNavState'
const FFAMBanner = dynamic(() => import('components/FFAMBanner'))
const SiteWideBanner = dynamic(() => import('components/SiteWideBanner'))

export default function LayoutContent({
  children,
  alignContentBottom,
  showHeader,
  showProgressPage,
  closeFFAMBanner,
  isFFAMReferrer,
  ffamReferrerContent,
  handleCloseDialog,
  emergencyBanners,
  usesSiteWideBanner,
  isFFAMDisabled,
  menuMobileLeft,
}) {
  const [mobileNavOpen] = useMobileNavState()

  const renderEmergencyBanners = () => {
    const list = []
    for (let i = 0; i < emergencyBanners.length; i++) {
      const element = emergencyBanners[i]
      list.push(
        <SiteWideBanner
          title={element?.fields?.title}
          message={element?.fields?.message}
          handleCloseDialog={() => {}}
        />
      )
    }
    return list
  }

  return (
    <div
      className={classNames(
        styles['max-width-container'],
        'group transition-transform duration-300 ease-in-out transform',
        {
          'translate-x-[17rem]': mobileNavOpen && menuMobileLeft,
        }
      )}
      data-narrow={true}
      data-align-content-bottom={alignContentBottom}
    >
      <main
        className={classNames(styles.main, ultramarine.variable, 'font-ultramarine')}
        id="main-layout"
        data-no-header={!showHeader}
        data-show-progress={showProgressPage}
      >
        {!closeFFAMBanner && !isFFAMDisabled() && usesSiteWideBanner && (
          <FFAMBanner
            isFFAMReferrer={isFFAMReferrer}
            ffamReferrerContent={ffamReferrerContent}
            handleCloseDialog={handleCloseDialog}
          />
        )}
        {emergencyBanners?.length > 0 && renderEmergencyBanners()}
        {children}
      </main>
    </div>
  )
}
